import {Base} from "@/api/Base"

export class SalaryInformationDelete extends Base {
    path = "salaryInformation/delete"
}